import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderFourHComponent } from "./loader-4h.component";

@NgModule({
  declarations: [LoaderFourHComponent],
  imports: [CommonModule],
  exports: [LoaderFourHComponent],
})
export class LoaderFourHModule {}
